import { UserRole } from 'src/auth/types';
import { AdminAndMethodologist } from 'src/constants/roles';

export const canEditEmployeeRoles = [UserRole.SYSTEM_ADMIN, ...AdminAndMethodologist];
